import type { FC } from 'react';

import { Form } from '../Form';
import type { GenericFormProps } from '../GenericFormProps';
import { schema } from './schema';
import { UserAndPromoter } from './UserAndPromoter';

export const UserAndPromoterForm: FC<GenericFormProps<typeof UserAndPromoter, typeof schema>> = ({
  onSubmit,
  buttonSlot,
  defaultValues,
}) => (
  <Form
    buttonSlot={buttonSlot}
    defaultValues={defaultValues}
    formContentElement={UserAndPromoter}
    schema={schema}
    onSubmit={onSubmit}
  />
);
